import React from 'react'
import { useSelector } from 'react-redux'
import { CFormLabel } from '@coreui/react-pro'
import Select from 'react-select'
import {
  generateCareTeamByFacilityOptions,
  selectStyleDark,
  selectStyleLight,
} from '../../../../../utils/sharedCareTeamLogic'
import { getTheme } from '../../../../../redux/user/userSlice'

export default function PanelCareTeams({ onChange }) {
  const theme = useSelector(getTheme)
  const practice = useSelector((state) => state?.user?.practice)

  const facility_id = useSelector((state) => state.sidePanel.panelEncounter?.facility_id)
  const careTeam = useSelector((state) => state.sidePanel.panelEncounter?.careteam)

  const careTeamList = practice?.careteams || []
  const careTeamsEnabled = practice?.careteamsEnabled || false
  const careTeamByFacilityOptions = generateCareTeamByFacilityOptions(
    careTeamList,
    facility_id,
    careTeam,
  )
  return (
    careTeamsEnabled && (
      <div className="PanelCareTeam pb-3">
        <CFormLabel className="label">Care Team</CFormLabel>
        <Select
          aria-label="Care Team"
          options={careTeamByFacilityOptions}
          styles={theme === 'light' ? selectStyleLight : selectStyleDark}
          onChange={(data) => {
            onChange(data.value)
          }}
          value={careTeamByFacilityOptions?.find((item) => item?.value === careTeam)}
          hideSelectedOptions={true}
        />
      </div>
    )
  )
}
